 
import React, { ReactNode } from "react";
import { DV2 } from "../theme";
import { Card, TextLink, useDv2Theme } from "./Ui";

export interface RailStep {
    number: number;
    label: string;
    /** Résumé affiché sous une étape terminée (« Ben Abdel-Aziz », « 3 séances, 4 h 30 »). */
    detail?: ReactNode;
    /** Lien « Changer » vers l'étape, proposé quand elle est terminée. */
    onEdit?: () => void;
    editLabel?: string;
}

/**
 * Rail des quatre étapes, colonne de droite en version web : étape faite
 * (coche), en cours (pleine) ou à venir (cercle vide).
 */
const StepsRail = ({ steps, current }: { steps: RailStep[]; current: number }) => {
    const { primary, fontFamily } = useDv2Theme();
    return (
        <Card as="aside" aria-label="Étapes de la déclaration" style={{ display: "flex", flexDirection: "column", gap: 16, fontFamily }}>
            {steps.map((step) => {
                const done = step.number < current;
                const active = step.number === current;
                const circle: React.CSSProperties = done || active
                    ? { background: primary, color: "#fff", border: "none" }
                    : { background: "transparent", color: DV2.placeholder, border: `2px solid #C9D3E0` };
                return (
                    <div key={step.number} style={{ display: "flex", alignItems: "flex-start", gap: 12, color: done || active ? DV2.text : DV2.placeholder }} aria-current={active ? "step" : undefined}>
                        <div aria-hidden style={{ width: 28, height: 28, borderRadius: "50%", fontWeight: 800, fontSize: 13, display: "grid", placeItems: "center", flexShrink: 0, ...circle }}>
                            {done ? "✓" : step.number}
                        </div>
                        <div style={{ flex: 1, minWidth: 0, paddingTop: 4 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center" }}>
                                <span style={{ fontWeight: done || active ? 800 : 700 }}>{step.label}</span>
                                {done && step.onEdit && <TextLink label={step.editLabel ?? "Changer"} onClick={step.onEdit} size={12} />}
                            </div>
                            {done && step.detail && (
                                <div style={{ fontSize: 12, color: DV2.muted, marginTop: 2, lineHeight: 1.4 }}>{step.detail}</div>
                            )}
                        </div>
                    </div>
                );
            })}
        </Card>
    );
};

export default StepsRail;
